"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledMediaQuery = _interopRequireDefault(require("styled-media-query"));

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    font-size: 1.13rem;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    font-size: 1.277rem;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Section = _styledComponents["default"].section.withConfig({
  displayName: "Leader__Section",
  componentId: "sc-1ggwp5-0"
})(["padding:1rem;text-align:center;"]);

var Overline = _styledComponents["default"].span.withConfig({
  displayName: "Leader__Overline",
  componentId: "sc-1ggwp5-1"
})(["font-size:0.731rem;font-weight:800;line-height:1;letter-spacing:0.2px;margin:0;"]);

var Body = _styledComponents["default"].h3.withConfig({
  displayName: "Leader__Body",
  componentId: "sc-1ggwp5-2"
})(["font-size:1.33rem;font-weight:400;margin:0.5rem 0 1.5rem 0;", " ", ""], _styledMediaQuery["default"].lessThan('medium')(_templateObject()), _styledMediaQuery["default"].lessThan('small')(_templateObject2()));

var Leader = function Leader(_ref) {
  var children = _ref.children,
      description = _ref.description,
      fluid = _ref.fluid,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    maxWidth: "md"
  }, /*#__PURE__*/_react["default"].createElement(Section, null, fluid && /*#__PURE__*/_react["default"].createElement(_gatsbyImage["default"], {
    fluid: fluid,
    alt: title,
    objectFit: "contain",
    objectPosition: "50% 50%",
    style: {
      display: 'block',
      margin: 'auto',
      height: 65,
      width: 65
    }
  }), /*#__PURE__*/_react["default"].createElement(Overline, null, title), /*#__PURE__*/_react["default"].createElement(Body, null, description), children));
};

Leader.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object]),
  title: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string.isRequired,
  fluid: _propTypes["default"].shape({
    src: _propTypes["default"].string
  })
};
Leader.defaultProps = {
  children: null,
  fluid: null
};
var _default = Leader;
exports["default"] = _default;